/* eslint-disable */
import React, {useEffect, useRef, useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import {useSelector} from 'react-redux'
import {
  selectDigitalPlanetPdfData,
  selectDigitalPlanetLoading,
} from '../../../redux/slices/digitalplanetinvoice.slice'

function PdfPreviewModal({uuid, onClose}) {
  const pdfData = useSelector(selectDigitalPlanetPdfData)
  const loading = useSelector(selectDigitalPlanetLoading)
  const blobUrlRef = useRef(null)
  const [blobUrl, setBlobUrl] = useState(null)

  useEffect(() => {
    if (pdfData?.data) {
      const blob = new Blob([pdfData.data], {type: 'application/pdf'})
      const url = URL.createObjectURL(blob)
      blobUrlRef.current = url
      setBlobUrl(url)
    }
    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
        blobUrlRef.current = null
      }
    }
  }, [pdfData])

  return (
    <Modal show={!!uuid} onHide={onClose} size='xl' centered>
      <Modal.Header closeButton>
        <Modal.Title>PDF Önizleme — {uuid}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{minHeight: 600}}>
        {loading && (
          <div className='d-flex justify-content-center align-items-center' style={{height: 560}}>
            <Spinner animation='border' />
          </div>
        )}
        {!loading && blobUrl && (
          <iframe
            src={blobUrl}
            title='PDF Önizleme'
            width='100%'
            height='560px'
            style={{border: 'none'}}
          />
        )}
        {!loading && !blobUrl && (
          <div className='text-center text-muted py-8'>PDF yüklenemedi.</div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export {PdfPreviewModal}
